export default "__VITE_ASSET__6dca9572__"